import React from 'react';
import { styled } from '@mui/material';

import { Button, Checkbox, Divider, IconButton, Radio, RadioGroup, Stack, Text } from 'shell/components';

const FilterDrawerInner = ({ filterDrawer: filterState, setFilterDrawer: setFilterState }) => {
    const checkedFiltersCount = filterState.statusFilterKeys.length + filterState.dueDateFilterKeys.length;

    return (
        <Stack divider={<Divider />} spacing={4}>
            <Stack>
                <IconButton
                    aria-label={'close'}
                    sx={{ alignSelf: 'flex-end' }}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={() => setFilterState((prev) => ({ ...prev, isOpen: false }))}
                />
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        Sort By
                    </Text>
                    <Button
                        variant={'tertiary'}
                        onClick={() =>
                            setFilterState((prev) => ({
                                ...prev,
                                sortKey: 'none',
                                statusFilterKeys: [],
                                dueDateFilterKeys: [],
                            }))
                        }
                    >
                        Reset All
                    </Button>
                </Stack>
                <Stack>
                    <CustomRadioGroup
                        value={filterState.sortKey}
                        onChange={(_, value) => setFilterState((prev) => ({ ...prev, sortKey: value }))}
                    >
                        <Radio label={'None'} labelPlacement={'start'} value={'none'} />
                        <Radio label={'Title A-Z'} labelPlacement={'start'} value={'titlea-z'} />
                        <Radio label={'Title Z-A'} labelPlacement={'start'} value={'titlez-a'} />
                        <Radio label={'Closest Due'} labelPlacement={'start'} value={'closestdue'} />
                        <Radio label={'Furthest Due'} labelPlacement={'start'} value={'furthestdue'} />
                    </CustomRadioGroup>
                </Stack>
            </Stack>
            <Stack>
                <Text variant={'h6'} weight={'semibold'}>
                    Filters {checkedFiltersCount ? `(${checkedFiltersCount})` : ''}
                </Text>
                <CustomText color={'light'} variant={'p1'}>
                    Status
                </CustomText>
                <CustomStack>
                    <Checkbox
                        checked={filterState.statusFilterKeys.includes('published')}
                        label={'Published'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                statusFilterKeys: current.statusFilterKeys.includes('published')
                                    ? current.statusFilterKeys.filter((key) => key !== 'published')
                                    : [...current.statusFilterKeys, 'published'],
                            }))
                        }
                    />
                    <Checkbox
                        checked={filterState.statusFilterKeys.includes('scheduled')}
                        label={'Scheduled'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                statusFilterKeys: current.statusFilterKeys.includes('scheduled')
                                    ? current.statusFilterKeys.filter((key) => key !== 'scheduled')
                                    : [...current.statusFilterKeys, 'scheduled'],
                            }))
                        }
                    />
                    <Checkbox
                        checked={filterState.statusFilterKeys.includes('draft')}
                        label={'Saved as Draft'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                statusFilterKeys: current.statusFilterKeys.includes('draft')
                                    ? current.statusFilterKeys.filter((key) => key !== 'draft')
                                    : [...current.statusFilterKeys, 'draft'],
                            }))
                        }
                    />
                </CustomStack>
                <CustomText color={'light'} variant={'p1'}>
                    Due Date
                </CustomText>
                <CustomStack>
                    <Checkbox
                        checked={filterState.dueDateFilterKeys.includes('today')}
                        label={'Today'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                dueDateFilterKeys: current.dueDateFilterKeys.includes('today')
                                    ? current.dueDateFilterKeys.filter((key) => key !== 'today')
                                    : [...current.dueDateFilterKeys, 'today'],
                            }))
                        }
                    />
                    <Checkbox
                        checked={filterState.dueDateFilterKeys.includes('thisweek')}
                        label={'This Week'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                dueDateFilterKeys: current.dueDateFilterKeys.includes('thisweek')
                                    ? current.dueDateFilterKeys.filter((key) => key !== 'thisweek')
                                    : [...current.dueDateFilterKeys, 'thisweek'],
                            }))
                        }
                    />
                    <Checkbox
                        checked={filterState.dueDateFilterKeys.includes('nextweek')}
                        label={'Next Week'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                dueDateFilterKeys: current.dueDateFilterKeys.includes('nextweek')
                                    ? current.dueDateFilterKeys.filter((key) => key !== 'nextweek')
                                    : [...current.dueDateFilterKeys, 'nextweek'],
                            }))
                        }
                    />
                    <Checkbox
                        checked={filterState.dueDateFilterKeys.includes('overdue')}
                        label={'Overdue'}
                        labelPlacement={'start'}
                        onChange={() =>
                            setFilterState((current) => ({
                                ...current,
                                dueDateFilterKeys: current.dueDateFilterKeys.includes('overdue')
                                    ? current.dueDateFilterKeys.filter((key) => key !== 'overdue')
                                    : [...current.dueDateFilterKeys, 'overdue'],
                            }))
                        }
                    />
                </CustomStack>
            </Stack>
        </Stack>
    );
};

const CustomRadioGroup = styled(RadioGroup)(() => {
    return {
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

const CustomText = styled(Text)(({ theme }) => {
    return {
        margin: theme.spacing(2, 0, 1),
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        paddingLeft: theme.spacing(2),
        '& label': {
            justifyContent: 'space-between',
        },
    };
});

export default FilterDrawerInner;
